import { Price } from '@/types/api';

export const priceToString = (price: Price): string => {
    return (new Intl.NumberFormat(['en-GB', 'en'], {
        style: 'currency',
        currency: price.CurrencyCode,
        currencyDisplay: 'symbol',
        useGrouping: true,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    })).format(parseFloat(price.Amount));
};
